import { InstitutionalPage } from '@/components/institutional-page'

export function AboutPage() {
  return InstitutionalPage({
    title: 'About - ResumeHeaders',
    heading: 'About ResumeHeaders',
    markdownUrl: '/content/about.md',
    background: 'light',
    showHeader: true,
    showFooter: true,
  })
}
